import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LatestFormSubmissionRow } from '../latest-form-submission-row.model';

@Component({
  selector: 'app-latest-form-submissions-item',
  templateUrl: './latest-form-submissions-item.component.html',
  styleUrls: ['./latest-form-submissions-item.component.scss'],
  standalone: false
})
export class LatestFormSubmissionsItemComponent {
  @Input() item: LatestFormSubmissionRow;

  constructor(private router: Router) {}

  onItemClicked(item: LatestFormSubmissionRow) {
    if (item.respondentId) {
      this.router.navigateByUrl(
        `/people/profile/${item.respondentId}/(forms//details:form/${item.id})`
      );
    }
  }

  onItemKeydown(event: KeyboardEvent, item: LatestFormSubmissionRow) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onItemClicked(item);
    }
  }
}
